<template>
  <button
    :disabled="loading || disabled"
    :class="[
      'inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200',
      loading ? 'opacity-75 cursor-not-allowed' : '',
      disabled ? 'opacity-50 cursor-not-allowed' : '',
      variantClasses
    ]"
    @click="$emit('click', $event)"
  >
    <!-- Loading Spinner -->
    <svg
      v-if="loading"
      class="animate-spin -ml-1 mr-2 h-4 w-4 text-current"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    
    <!-- Button Content -->
    <span v-if="!loading">{{ text }}</span>
    <span v-else>{{ loadingText || 'Processing...' }}</span>
  </button>
</template>

<script>
export default {
  name: 'LoadingButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    loadingText: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'success', 'warning', 'danger', 'info'].includes(value)
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value)
    }
  },
  emits: ['click'],
  computed: {
    variantClasses() {
      const variants = {
        primary: 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500',
        secondary: 'bg-gray-600 text-white hover:bg-gray-700 focus:ring-gray-500',
        success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
        warning: 'bg-yellow-600 text-white hover:bg-yellow-700 focus:ring-yellow-500',
        danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
        info: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500'
      }
      
      const sizes = {
        sm: 'px-2 py-1 text-xs',
        md: 'px-4 py-2 text-sm',
        lg: 'px-6 py-3 text-base'
      }
      
      return `${variants[this.variant]} ${sizes[this.size]} focus:outline-none focus:ring-2 focus:ring-offset-2`
    }
  }
}
</script>
